import type {
  FormGrantCreatePayload,
  FormGrantUpdatePayload,
  FormUserGrantDto,
} from "../types/formGrant";
import {
  normalizeFormUserGrant,
  normalizeFormUserGrants,
} from "../lib/forms/formGrants";
import { apiRequest } from "./client";

function grantsPath(formId: number): string {
  return `/api/v1/forms/${formId}/grants`;
}

function grantPath(formId: number, grantId: number): string {
  return `${grantsPath(formId)}/${grantId}`;
}

function requireGrant(raw: unknown, message: string): FormUserGrantDto {
  const grant = normalizeFormUserGrant(raw);
  if (!grant) {
    throw new Error(message);
  }
  return grant;
}

/** GET /api/v1/forms/{formId}/grants */
export function fetchFormGrants(formId: number): Promise<FormUserGrantDto[]> {
  return apiRequest<unknown>(grantsPath(formId)).then(normalizeFormUserGrants);
}

/** POST /api/v1/forms/{formId}/grants */
export function createFormGrant(
  formId: number,
  payload: FormGrantCreatePayload,
): Promise<FormUserGrantDto> {
  return apiRequest<unknown>(grantsPath(formId), {
    method: "POST",
    body: JSON.stringify({
      chmId: payload.chmId.trim(),
      role: payload.role,
    }),
  }).then((body) => requireGrant(body, "Некорректный ответ создания гранта"));
}

/** PATCH /api/v1/forms/{formId}/grants/{grantId} */
export function updateFormGrant(
  formId: number,
  grantId: number,
  payload: FormGrantUpdatePayload,
): Promise<FormUserGrantDto> {
  return apiRequest<unknown>(grantPath(formId, grantId), {
    method: "PATCH",
    body: JSON.stringify(payload),
  }).then((body) => requireGrant(body, "Некорректный ответ обновления гранта"));
}

/** DELETE /api/v1/forms/{formId}/grants/{grantId} */
export function deleteFormGrant(formId: number, grantId: number): Promise<void> {
  return apiRequest<void>(grantPath(formId, grantId), {
    method: "DELETE",
  });
}
